import { useEffect } from "react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import ExitIntent from "@/components/site/ExitIntent";
import JoinHero from "@/components/site/join/JoinHero";
import OpportunitySection from "@/components/site/join/OpportunitySection";
import OfferSection from "@/components/site/join/OfferSection";
import ProcessSection from "@/components/site/join/ProcessSection";
import WhoSection from "@/components/site/join/WhoSection";
import TestimonialSection from "@/components/site/join/TestimonialSection";
import ApplySection from "@/components/site/join/ApplySection";

export default function JoinTeam() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <Navigation transparentUntilScroll />
      <main>
        <JoinHero />
        <OpportunitySection />
        <OfferSection />
        <ProcessSection />
        <WhoSection />
        <TestimonialSection />
        <ApplySection />
      </main>
      <Footer />
      <ExitIntent
        eyebrow="Before you go"
        headline="Talk to Dan about the partner program."
        body="A 15-minute call is the fastest way to see if the SmartEdge partner program is a fit for your network. No obligation."
        ctaLabel="Schedule your onboarding call"
      />
    </>
  );
}
